import { render, staticRenderFns } from "./CompanyTrends.vue?vue&type=template&id=2dc8d258&scoped=true&"
import script from "./CompanyTrends.vue?vue&type=script&lang=js&"
export * from "./CompanyTrends.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTrends.vue?vue&type=style&index=0&id=2dc8d258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8d258",
  null
  
)

export default component.exports